import { Field, useFormikContext } from 'formik';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import formatPhoneNumber from 'src/util/formatPhoneNumber';

const fields = [
  {
    className: 'col-span-12 sm:col-span-7 lg:col-span-3',
    label: 'Property Owner Name',
    name: 'name',
    type: 'text',
  },
  {
    className: 'col-span-12 sm:col-span-7 lg:col-span-3',
    label: 'Email Address',
    name: 'email',
    type: 'email',
  },
  {
    className: 'col-span-12 sm:col-span-7 lg:col-span-3',
    label: 'Primary Phone',
    name: 'primaryPhone',
    type: 'tel',
  },
  {
    className: 'col-span-12 sm:col-span-7 lg:col-span-3',
    label: 'Secondary Phone',
    name: 'secondaryPhone',
    type: 'tel',
  },
];

export default function OwnerInfoField() {
  const form = useFormikContext();

  return (
    <div className="flex flex-col gap-4">
      {fields.map(({ name, placeholder, label, type, className }, index) => {
        return (
          <div key={index}>
            <Field
              className={className}
              InputLabelProps={{ shrink: true }}
              component={MuiValidTextField}
              inputProps={{ maxLength: 100 }}
              label={label}
              name={`owner.${name}`}
              onChange={({ target }) => {
                if (type === 'tel') {
                  form.setFieldValue(`owner.${name}`, formatPhoneNumber(target.value));
                } else {
                  form.setFieldValue(`owner.${name}`, target.value);
                }
              }}
              placeholder={placeholder}
              type={type}
              variant="outlined"
            />
          </div>
        );
      })}
    </div>
  );
}
